<template src="./Index.html">
</template>

<script>
import AddView from "./actions/Add";
import EditView from "./actions/Edit";
import DetailsView from "./details/Details";
import ReturnView from "./actions/Return";

export default {
    components: {
        AddView,
        EditView,
        DetailsView,
        ReturnView,
    },
    created() {
        this.getAll();
        this.$store.dispatch("lookups/getLookups")

    },
    computed: {
        userTypes() {
            return [

                { value: false, label: "الشؤون الإدارية والخدمات" },
                { value: true, label: " الموظف" },
            ]

            // return [{value:0,label:"الكل"} ,...this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.UserTypes).filter(
            //     (i) => i.value !== 14001
            // )]

        },
        employeeLeaves() {
            return this.$store.state.employeeLeaves.employeeLeaves;
        },
        pageCount() {
            return Math.ceil(
                this.$store.state.employeeLeaves.totalItems / this.filters.pageSize
            );
        },
    },
    data() {
        return {
            permissions: this.$empOperationsPermissions.EmployeeLeavesPermissions,



            expireStatus: [
                { value: -1, label: "الكل" },
                { value: 0, label: "تنتهي اليوم" },
                { value: 1, label: "تنتهي بالغد " },
                { value: 2, label: "تنتهي بعد يومان " },
                { value: 4, label: "اكتر من يومان " },
                { value: 5, label: "منتهيه مسبقا " },
            ],

            items: [
                {
                    text: "الاجراءات ",
                },
                {
                    text: "إدارة اجازات الموظفين",
                },
            ],
            totalItems: 0,
            subtitle: "قائمة الموظفين",
            dialog: false,
            dialogType: null,
            dialogMessage: "",
            itemId: 0,
            view: 0,
            filters: {
                page: 1,
                pageSize: 10,
                // userTypeId: 0,
                byEmployee: null,
                employeeNo: null,
                startDate: null,
                endDate: null,
                expireStatusId: -1
            },
            headers: [
                {
                    text: "اسم الموظف بالكامل",
                    value: "fullName",
                    sortable: false,
                    align: "start",
                },

                {
                    text: "نوع الاجازة",
                    value: "vacationType",
                    sortable: false,
                    align: "start",
                },

                {
                    text: "تاريخ البداية ",
                    value: "startDate",
                    sortable: false,
                    align: "start",
                },
                {
                    text: "مدة الاجازة بالايام ",
                    value: "duration",
                    sortable: false,
                    align: "center",
                },



                // { text: "نوع التقديم ", value: "userType", sortable: false },
                { text: "نوع التقديم ", value: "byEmployee", sortable: false },
                { text: "اشعار الانتهاء  ", value: "isExpireTmr", sortable: false, align: "center", },
                { text: "الحالة ", value: "status", sortable: false },
                { text: "مسجل بواسطة", value: "createdBy", sortable: false },
                { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
                {
                    text: "الإجراءات",
                    value: "actions",
                    sortable: false,
                    align: "center",
                },
            ],
        };
    },
    methods: {
        download() {
            let filters = {
                byEmployee: this.filters.byEmployee,
                employeeNo: this.filters.employeeNo,
                startDate: this.filters.startDate,
                endDate: this.filters.endDate,
                expireStatusId: this.filters.expireStatusId,
            };

            const paramsString = Object.entries(filters)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            window.open(`/api/employeeLeaves/excel?${paramsString}`, "_blank");
        },
        allowedDates(val) {
            const today = new Date();
            today.setFullYear(today.getFullYear() - 15);
            const date = new Date(val);
            return date < today;
        },
        getAll(page) {
            this.filters.page = page || 1;
            this.$store.dispatch("employeeLeaves/getAll", this.filters);
        },
        addItem() {
            this.view = 1;
            this.items.push({ text: "إضافة اجازة جديدة" });

        },
        editItem(item) {
            this.itemId = item.employeeLeaveId;
            this.view = 2;
            this.items.push({ text: "تعديل بيانات الاجازة" });

        },
        returnItem(item) {
            this.itemId = item.employeeLeaveId;
            this.view = 4;
            this.items.push({ text: "قطع  الاجازة" });

        },
        showDetails(item) {
            this.itemId = item.employeeLeaveId;
            this.view = 3;
            this.items.push({ text: "عرض التفاصيل" });

        },
        showDialog(item, type) {
            switch (type) {
                case "delete":
                    this.dialogMessage = "هل انت متأكد من بحذف طلب الاجازة";
                    break;
                case "cancel":
                    this.dialogMessage = "هل انت متأكد من رغبتك برفض طلب الاجازة";
                    break;
                case "approve":
                    this.dialogMessage = "هل انت متأكد من رغبتك بالموافقة على طلب الاجازة";
                    break;
                case "reject":
                    this.dialogMessage = "هل انت متأكد من رغبتك برفض طلب الاجازة";
                    break;

            }
            this.dialogType = type;
            this.itemId = item.employeeLeaveId;
            this.dialog = true;
        },

        confirmDialog() {
            this.$store.dispatch(`employeeLeaves/${this.dialogType}`, this.itemId);
            this.cancelDialog();
        },

        cancelDialog() {
            this.dialog = false;
            this.itemId = 0;
            this.dialogMessage = "";
            this.dialogType = null;
        },

        viewPrint(item) {
            const routeData = this.$router.resolve(`/PrintLeave/${item.employeeLeaveId}`);

  
            window.open(routeData.href, "_blank");
        },
        back() {
            this.view = 0;
            this.items = [
                {
                    text: "الاجراءات ",
                },
                {
                    text: "إدارة اجازات الموظفين",
                },
            ];
        },
        reload() {
            this.filters.departmentName = null;
            this.filters.byEmployee = null;
            this.getAll(1);
            this.back();
        },
    },
};
</script>
